import { IndexedDBStorage } from './indexed-db-storage';
import { LocalStorage } from './local-storage';
import { SessionStorage } from './session-storage';
import { StorageTypes } from './types';
import { flushItemsMatching, flushExpiredItemsMatching, getStandardizedOptions } from './utilities';
import { WebStorage } from './WebStorage';
const DEFAULT_DB_NAME = 'tgt';
const DEFAULT_STORE_NAME = 'webStore';
const sessionStorage = new SessionStorage(DEFAULT_DB_NAME, DEFAULT_STORE_NAME);
export { WebStorage, IndexedDBStorage, LocalStorage, SessionStorage, sessionStorage, StorageTypes, flushItemsMatching, flushExpiredItemsMatching, getStandardizedOptions, };
export default new WebStorage(DEFAULT_DB_NAME, DEFAULT_STORE_NAME);
